import { useState, useEffect } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);
  const reduce = useReducedMotion();

  useEffect(() => {
    const fn = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", fn, { passive: true });
    fn();
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: reduce ? "instant" : "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, y: 20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
          onClick={scrollTop}
          data-testid="back-to-top"
          aria-label="Voltar ao topo"
          title="Voltar ao topo"
          className="fixed bottom-24 sm:bottom-28 left-4 sm:left-6 z-40 w-11 h-11 rounded-full bg-white/90 dark:bg-[#101828]/90 backdrop-blur-md border border-slate-200 dark:border-white/15 text-slate-600 dark:text-slate-300 shadow-[0_6px_20px_rgba(0,0,0,0.10)] flex items-center justify-center hover:bg-[#1698AC] hover:text-white hover:border-[#1698AC] active:scale-95 transition-all"
        >
          <ArrowUp size={17} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
